export default [
  {
    title: 'cssCursorGenerator.generalTitle',
    data: ['default', 'none'],
  },
  {
    title: 'cssCursorGenerator.statusTitle',
    data: ['help', 'pointer', 'progress', 'wait', 'context-menu', 'not-allowed'],
  },
  {
    title: 'cssCursorGenerator.selectionTitle',
    data: ['cell', 'crosshair', 'text', 'vertical-text'],
  },

  { title: 'cssCursorGenerator.zoomTitle', data: ['zoom-in', 'zoom-out'] },

  { title: 'cssCursorGenerator.dragAndDropTitle', data: ['alias', 'copy', 'move', 'no-drop', 'grab', 'grabbing'] },

  {
    title: 'cssCursorGenerator.resizeTitle',
    data: [
      'all-scroll',
      'col-resize',
      'row-resize',
      'n-resize',
      'e-resize',
      's-resize',
      'w-resize',
      'ns-resize',
      'ew-resize',
      'ne-resize',
      'nw-resize',
      'se-resize',
      'sw-resize',
      'nesw-resize',
      'nwse-resize',
    ],
  },
];
